import React, { useEffect } from "react";
import queryString from 'query-string';
import { useLocation } from 'react-router-dom'


const DocusignBridge = () => {

 const SUCCESS_EVENTS = new Set(["signing_complete"]); 
 const location = useLocation()
  useEffect(() => {
    const qs = queryString.parse(location.search);
    const event = (qs.event || "").toLowerCase();   
    const envelopeId = qs.envelopeId || undefined;
    const subscriptionType = qs.subscriptionType; 
    const payType = qs.payType;
    const token = qs.token;
    const nonce = qs.nonce || undefined;            
    const sid = qs.sid || undefined;     
    const memId = qs.memId;
    const startDate = qs.startDate;
    const endDate = qs.endDate;
    const selectedPricing = qs.selectedPricing    
    const isEligibleForAddon = qs.isEligibleForAddon      

    const payloadBase = {
      sid, nonce, envelopeId, event, subscriptionType, payType, token, memId, startDate, endDate, selectedPricing, isEligibleForAddon
    };

    const targetOrigin = window.location.origin;

    if (SUCCESS_EVENTS.has(event)) {
      window.parent.postMessage({ type: "DOCUSIGN_DONE", ...payloadBase }, targetOrigin);
    } else {
      window.parent.postMessage({ type: "DOCUSIGN_EVENT", event, ...payloadBase }, targetOrigin);
    }
  }, []);

  return <div style={{ padding: 16 }}>Finishing up…</div>

}

export default DocusignBridge